import { FirebaseMessaging } from '../firebaseMessaging/firebaseMessaging';

export const getDeviceToken = async (): Promise<string> => {
  const { token } = await FirebaseMessaging.getToken();
  return token;
};
